<template>
    <div>
        <div class="tab-header-container">
            <h2 class="form-label">Документи</h2>
            <LiteButton @click.native="addButtonClicked"
                        class="edit-button"
                        :hoverColor="'green'"
                        :icon="'far fa-plus-square'">
            </LiteButton>
        </div>

        <hr class="form-line"/>

        <CarDocumentList v-if="!shouldAdd"/>
        <CarDocumentCreateForm class="popup-shadow" v-if="shouldAdd" :carId="parseInt(workerId)" @close-clicked="closedAddForm"/>
    </div>
</template>

<script>
    import LiteButton from "@/shared/components/button/LiteButton"
    import CarDocumentCreateForm from "@/components/car/document/CarDocumentCreateForm";
    import CarDocumentList from "@/components/car/document/CarDocumentList";

    export default {
        name: "CarDocuments",
        components: {CarDocumentList, CarDocumentCreateForm, LiteButton},
        data() {
          return {
              workerId: this.$route.params.id,
              shouldAdd: false,
          }
        },
        methods: {
            addButtonClicked() {
                this.$store.commit('setHasModal', true);
                this.shouldAdd = true;
            },
            closedAddForm() {
                this.$store.commit('setHasModal', false);
                this.shouldAdd = false;
            }
        }
    }
</script>

<style scoped>

</style>
